import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 3CF63E10-42E7-4E13-8BFF-10E9257953AB
 * name octagon-outline
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/octagon-outline.svg
 * tags
 * - Shape 
 * - Transportation + Road 
 */
export const OctagonOutlineIcon = createSvgIcon(<><path d="M8.27,3L3,8.27V15.73L8.27,21H15.73C17.5,19.24 21,15.73 21,15.73V8.27L15.73,3M9.1,5H14.9L19,9.1V14.9L14.9,19H9.1L5,14.9V9.1" /></>, 'OctagonOutlineIcon');
export default OctagonOutlineIcon